import { Icon, Tab } from "semantic-ui-react"
import React, { useEffect, useState } from "react"
import RewardsDashboardCard from "../../../../v2/components/Rewards/RewardsDashboardCard"
import { ReactComponent as GiftOpen } from "../../../../images/gift-open.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleRight } from "@fortawesome/free-solid-svg-icons"
import { ReactComponent as Tick } from "../../../../images/tick-dynamic.svg"
import { ReactComponent as Calender } from "../../../../images/calendar-icon-dynamic.svg"
import { ReactComponent as Pulse } from "../../../../images/pulse.svg"
import { ReactComponent as Gain } from "../../../../images/gain.svg"
import { ReactComponent as Loss } from "../../../../images/loss.svg"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { routerPaths } from "../../../constants/paths"
import { getRewardsHistory } from "../../../actions/rewards"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"

const Rewards = ({ history, getRewardsHistory, rewards, user }) => {
  const panes = [
    {
      menuItem: "Points activity",
      render: () => <PointsActivityTab history={rewards?.history} />
    },
    {
      menuItem: "Earn points",
      render: () => <EarnPointsTab user={user} />
    }
  ]

  useEffect(() => {
    getRewardsHistory()
  }, [])

  return (
    <div className="rewards-account">
      <h1 className="page-title">CarAdvise Rewards</h1>

      <RewardsDashboardCard />

      <div className="rewards-tab">
        <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
      </div>

      <div className="program-rules-card" onClick={() => history.push(routerPaths.rewardRules)}>
        <p>Program Rules</p>
        <FontAwesomeIcon icon={faAngleRight} />
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    rewards: state.rewards,
    user: state.user || {}
  }
}

export default withRouter(
  connect(mapStateToProps, {
    getRewardsHistory
  })(Rewards)
)

const PointsActivityTab = ({ history }) => {
  const [viewLimit, setViewLimit] = useState(5)

  if (history?.length > 0) {
    return (
      <div className="points-tab">
        <div className="points-list">
          {history.slice(0, viewLimit).map((item, index) => {
            return (
              <EarnPointsCard
                title={item.description}
                date={item.created_at}
                shopName={item.shop_name}
                Icon={item.event_type === "earn" ? EarnIcon : BurnIcon}
                points={item.display_miles}
                type={item.event_type}
              />
            )
          })}
        </div>

        {viewLimit < history.length && (
          <p className="show-more" onClick={() => setViewLimit(viewLimit + 5)}>
            Show more
          </p>
        )}
      </div>
    )
  }

  return (
    <div className="points-empty">
      <GiftOpen />

      <div className="empty-text">
        <p>Your reward account is empty.</p>
        <p>Book a service today to start earning</p>
      </div>
    </div>
  )
}

const EarnPointsTab = ({ user }) => {
  const oneTimeActivities = [
    {
      title: "Add your first vehicle",
      description: "",
      completed: false,
      points: 500
    },
    {
      title: "Add your second vehicle",
      description: "",
      completed: false,
      points: 200
    },
    {
      title: "1st service completion",
      description: "",
      completed: false,
      points: 500
    },
    {
      title: "1st booking bonus",
      description: "",
      completed: false,
      points: 150
    },
    {
      title: "Odometer update",
      description: "Update in your dashboard",
      completed: false,
      points: 50
    }
  ]

  const showOneTimeActivities = () => {
    return new Date(user.created_at) > new Date("2026-05-21")
  }

  return (
    <div className="earn-tab">
      <p className="section-title">Recurring activities</p>
      <EarnPointsCard
        title="Service bookings"
        description="Always applied at checkout (1 pt for $1)"
      />
      <p className="section-title">One-time activities</p>
      {showOneTimeActivities() ? (
        oneTimeActivities.map((activity) => (
          <EarnPointsCard
            title={activity.title}
            description={activity.description}
            completed={activity.completed}
            points={"+" + activity.points}
          />
        ))
      ) : (
        <div className="one-time-activity-info">
          <FontAwesomeIcon icon={faInfoCircle} />
          <p>
            Points cannot be earned on past activities. One-time activity points are available only
            to new customers as of May 21, 2026.
          </p>
        </div>
      )}
    </div>
  )
}

const EarnPointsCard = ({
  title,
  description,
  completed,
  points,
  date,
  shopName,
  Icon,
  type = "earn"
}) => {
  const formattedDate = new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric"
  })

  return (
    <div className="earn-card">
      <div className="earn-card-left">
        {Icon && <Icon />}

        <div className="earn-card-content">
          <p className="title">{title}</p>

          {date && (
            <div className="date">
              <Calender />
              <p>{formattedDate}</p>
            </div>
          )}

          {shopName && <p className="meta">{shopName}</p>}

          {!completed && description && <p className="meta">{description}</p>}

          {completed && (
            <div className="completed">
              <Tick />
              <p>Completed</p>
            </div>
          )}
        </div>
      </div>

      <p className={`points ${type}`}>{points ?? "+1"}</p>
    </div>
  )
}

const PulseIcon = () => (
  <div className="rewards-icon rewards-icon--neutral">
    <Pulse />
  </div>
)

const EarnIcon = () => (
  <div className="rewards-icon rewards-icon--success">
    <Gain color="#2E7D32" />
  </div>
)

const BurnIcon = () => (
  <div className="rewards-icon rewards-icon--danger">
    <Loss color="#E7000B" />
  </div>
)
